import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row g-4 justify-content-center mb-4" }
const _hoisted_3 = { class: "col-12 col-md-6 col-xl-3" }
const _hoisted_4 = { class: "card h-100" }
const _hoisted_5 = { class: "card-body d-flex flex-column justify-content-center align-items-center" }
const _hoisted_6 = { class: "card-title display-4 fw-bold mb-0" }
const _hoisted_7 = { class: "card-footer" }
const _hoisted_8 = { class: "row g-2 text-center" }
const _hoisted_9 = { class: "col-6 col-sm-3" }
const _hoisted_10 = { class: "h5 mb-0 text-success fw-bold" }
const _hoisted_11 = { class: "col-6 col-sm-3" }
const _hoisted_12 = { class: "h5 mb-0 text-danger fw-bold" }
const _hoisted_13 = { class: "col-6 col-sm-3" }
const _hoisted_14 = { class: "h5 mb-0 text-warning fw-bold" }
const _hoisted_15 = { class: "col-6 col-sm-3" }
const _hoisted_16 = { class: "h5 mb-0 text-secondary fw-bold" }
const _hoisted_17 = { class: "col-12 col-md-6 col-xl-3" }
const _hoisted_18 = { class: "card h-100" }
const _hoisted_19 = { class: "card-body d-flex flex-column justify-content-center" }
const _hoisted_20 = { class: "row align-items-center" }
const _hoisted_21 = { class: "col-6 text-center border-end" }
const _hoisted_22 = { class: "col-6 text-center" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "row align-items-center" }
const _hoisted_28 = { class: "col-6 text-center border-end" }
const _hoisted_29 = { class: "mb-0 fw-bold text-info" }
const _hoisted_30 = { class: "col-6 text-center" }
const _hoisted_31 = { class: "mb-0 fw-bold text-info" }
const _hoisted_32 = {
  key: 0,
  class: "col-12 col-xl-6 col-xxl-3"
}
const _hoisted_33 = {
  key: 1,
  class: "col-12 col-xl-6 col-xxl-3"
}
const _hoisted_34 = {
  key: 2,
  class: "col-12 col-xl-6 col-xxl-3"
}
const _hoisted_35 = {
  key: 3,
  class: "col-12 col-xl-6 col-xxl-3"
}
const _hoisted_36 = {
  key: 4,
  class: "col-12 col-md-6 col-xl-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StakesSummary = _resolveComponent("StakesSummary")!
  const _component_OperationsPieChart = _resolveComponent("OperationsPieChart")!
  const _component_OddsRadar = _resolveComponent("OddsRadar")!
  const _component_RiskRewardRadar = _resolveComponent("RiskRewardRadar")!
  const _component_StakesHistogram = _resolveComponent("StakesHistogram")!

  return (_ctx.kpis)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "card-header text-truncate" }, [
                _createElementVNode("i", { class: "fas fa-bell fa-fw text-primary" }),
                _createElementVNode("span", null, " Total Alertas")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.kpis.totalAlerts), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", {
                        class: "small text-success fw-bold text-uppercase text-nowrap",
                        style: {"font-size":"0.65rem"}
                      }, "Ganadas", -1)),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.kpis.wins), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _cache[1] || (_cache[1] = _createElementVNode("div", {
                        class: "small text-danger fw-bold text-uppercase text-nowrap",
                        style: {"font-size":"0.65rem"}
                      }, "Perdidas", -1)),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.kpis.losses), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _cache[2] || (_cache[2] = _createElementVNode("div", {
                        class: "small text-warning fw-bold text-uppercase text-nowrap",
                        style: {"font-size":"0.65rem"}
                      }, "Pendientes", -1)),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.kpis.pending), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("div", {
                        class: "small text-secondary fw-bold text-uppercase text-nowrap",
                        style: {"font-size":"0.65rem"}
                      }, "Anuladas", -1)),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.kpis.voids), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "card-header text-truncate" }, [
                _createElementVNode("i", { class: "fas fa-tachometer-alt fa-fw" }),
                _createElementVNode("span", null, " Rendimiento")
              ], -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "small text-muted text-uppercase fw-bold mb-1" }, " Tasa Acierto ", -1)),
                    _createElementVNode("h3", {
                      class: _normalizeClass(["mb-0 fw-bold", _ctx.kpis.winRate >= 50 ? 'text-success' : 'text-danger'])
                    }, _toDisplayString(_ctx.kpis.winRate.toFixed(1)) + "% ", 3)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.kpis.yield !== undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "small text-muted text-uppercase fw-bold mb-1" }, " Yield ", -1)),
                          _createElementVNode("h3", {
                            class: _normalizeClass(["mb-0 fw-bold", _ctx.kpis.yield >= 0 ? 'text-success' : 'text-danger'])
                          }, _toDisplayString(_ctx.kpis.yield >= 0 ? "+" : "") + _toDisplayString(_ctx.kpis.yield.toFixed(1)) + "% ", 3)
                        ]))
                      : (_ctx.kpis.pips !== undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "small text-muted text-uppercase fw-bold mb-1" }, " Pips ", -1)),
                            _createElementVNode("h3", {
                              class: _normalizeClass(["mb-0 fw-bold", _ctx.kpis.pips >= 0 ? 'text-success' : 'text-danger'])
                            }, _toDisplayString(_ctx.kpis.pips > 0 ? "+" : "") + _toDisplayString(_ctx.kpis.pips), 3)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("div", { class: "small text-muted text-uppercase fw-bold mb-1" }, " Yield ", -1),
                            _createElementVNode("h3", { class: "mb-0 fw-bold text-muted" }, "-", -1)
                          ]))]))
                  ])
                ]),
                (_ctx.isSportsBetting)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _cache[11] || (_cache[11] = _createElementVNode("hr", { class: "my-2 opacity-10" }, null, -1)),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "small text-muted text-uppercase fw-bold mb-1" }, " Stake Prom. ", -1)),
                          _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.averageStake) + "% ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "small text-muted text-uppercase fw-bold mb-1" }, " Cuota Media ", -1)),
                          _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.kpis.averageOdds ? _ctx.kpis.averageOdds.toFixed(2) : "-"), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (
          _ctx.isSportsBetting &&
          _ctx.kpis.stakeDistribution &&
          Object.keys(_ctx.kpis.stakeDistribution).length > 0
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createVNode(_component_StakesSummary, {
                  stakeDistribution: _ctx.kpis.stakeDistribution
                }, null, 8, ["stakeDistribution"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isSportsBetting && _ctx.alerts.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_OperationsPieChart, {
                  alerts: _ctx.alerts,
                  alertType: _ctx.alertType
                }, null, 8, ["alerts", "alertType"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSportsBetting && _ctx.alerts.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(_component_OddsRadar, { alerts: _ctx.alerts }, null, 8, ["alerts"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isSportsBetting && _ctx.alerts.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_RiskRewardRadar, { alerts: _ctx.alerts }, null, 8, ["alerts"])
              ]))
            : _createCommentVNode("", true),
          (
          (_ctx.isSportsBetting &&
            (!_ctx.kpis.stakeDistribution ||
              Object.keys(_ctx.kpis.stakeDistribution).length === 0)) ||
          (!_ctx.isSportsBetting && _ctx.alerts.length === 0)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("div", { class: "card h-100 bg-light border-dashed d-flex align-items-center justify-content-center" }, [
                  _createElementVNode("span", { class: "text-muted" }, "No hay suficientes datos")
                ], -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        (
        _ctx.isSportsBetting &&
        _ctx.kpis.stakeDistribution &&
        Object.keys(_ctx.kpis.stakeDistribution).length > 0 &&
        _ctx.alerts.length > 0
      )
          ? (_openBlock(), _createBlock(_component_StakesHistogram, {
              key: 0,
              alerts: _ctx.alerts
            }, null, 8, ["alerts"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}